<html class="notranslate">
    <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
    <meta http-equiv="Pragma" content="no-cache">
    <meta http-equiv="Expires" content="0">
    <app-translate></app-translate>
    <div  *ngIf="loading" class="spinnerOverlay" >
        <mat-spinner></mat-spinner>
    </div>
    <router-outlet></router-outlet>
</html>